// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectCurrency_select__23jdc","addon":"SelectCurrency_addon__1IGGM"};